import React from "react"
import PropTypes from "prop-types"
import wuloojLogoFull from "assets/images/superadmin/wulooj-logo-full.png"

const TenantAuthLogo = ({
  logoUrl = "",
  alt = "Logo",
  className = "login-platform-logo mb-4 mt-2",
  fallbackToPlatform = true,
}) => {
  const trimmedLogoUrl = logoUrl?.trim()

  if (!trimmedLogoUrl) {
    if (!fallbackToPlatform) {
      return null
    }

    return (
      <div className="text-center">
        <img src={wuloojLogoFull} alt={alt} className={className} />
      </div>
    )
  }

  return (
    <div className="text-center">
      <img src={trimmedLogoUrl} alt={alt} className={className} />
    </div>
  )
}

TenantAuthLogo.propTypes = {
  logoUrl: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
  fallbackToPlatform: PropTypes.bool,
}

export default TenantAuthLogo
